import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { UtmAlias as UtmAliasType, UtmAliasListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const UTM_ALIAS_FIELDS = `alias createdDate id orgId original type updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query UtmAliases($search: String, $pagination: PaginationInput, $sort: SortInput) {
    utmAliases(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        alias
        createdDate
        id
        orgId
        original
        type
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateUtmAliasStore($input: CreateUtmAliasInput!) {
    createUtmAlias(input: $input) {
      alias
      createdDate
      id
      orgId
      original
      type
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateUtmAliasStore($id: ID!, $input: UpdateUtmAliasInput!) {
    updateUtmAlias(id: $id, input: $input) {
      alias
      createdDate
      id
      orgId
      original
      type
      updatedDate
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteUtmAlias($id: ID!) {
    deleteUtmAlias(id: $id)
  }
`)

export class UtmAliasStore extends EntityStore<
  UtmAliasType,
  UtmAliasListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `UtmAlias`,
      extractList: (data: any) => data.utmAliases,
      extractMutated: (data: any) => data.updateUtmAlias ?? data.createUtmAlias,
    })
  }
}
